<template>
<div class="Reset Password">
    <vue-headful
        title="Designbox - Reset Password"
        description="Designbox"
    />
    <section class="section login">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-6 has-text-centered">
                    <h2 v-if="generic"><img v-show="site_logo" :src="site_logo" :alt="site_title" /><span v-show="! site_title_as_alt">{{ site_title }}</span></h2>
                    <form @submit.prevent="validateBeforeSubmit">
                        <b-field :label="$t('set-new-password')"
                            :type="{'is-danger': errors.has('password')}"
                            :message="errors.first('password')">
                            <b-input type="password" v-model="user.password" name="password" v-validate="'required|min:8'" />
                        </b-field>
                        <b-field :label="$t('repeat-password')"
                            :type="{'is-danger': errors.has('confirm-password')}"
                            :message="[{
                                'The confirm password field is required' : errors.firstByRule('confirm-password', 'required'),
                                'The confirm password is not valid' : errors.firstByRule('confirm-password', 'is')
                            }]">
                            <b-input type="password" v-model="user.password2" name="confirm-password"
                                v-validate="{ required: true, is: user.password }" />
                        </b-field>
                        <button type="submit" class="button is-primary"> {{ $t("change-password") }} </button>
                    </form>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import config         from '@/config'

export default {
    name: 'UserResetPassword',
    props: ['token'],
    data: function(){
        return {
            user:{
                token:'',
                username: '',
                password: '',
                password2:''
            },
            generic: config.generic,
            site_title: config.title,
            site_logo: config.logo,
            site_title_as_alt: config.title_as_alt,
        }
    },
    methods: {
        validateBeforeSubmit() {
            this.user.token = this.token;
            var self=this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("resetPassword",{user:this.user,self:self})
                }
            });
        }
    },
    created () {
        var self = this;
        this.$store.dispatch("callCurrentCompany",{self:self,company:this.cid});
    }
}
</script>
